/*
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2024-05-08 14:23:07
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-05-08 16:29:07
 */
import Layout from "@/layout/index.vue";
export default [
  {
    path: "/application",
    name: "Application",
    component: Layout,
    redirect: "/application/login",
    children: [
      {
        path: "/application/login",
        name: "ApplicationLogin",
        component: () => import("@/views/application/login"),
      },
      {
        path: "/application/list",
        name: "ApplicationList",
        component: () => import("@/views/application/list"),
      },
      {
        path: "/application/info",
        name: "ApplicationInfoAdd",
        component: () => import("@/views/application/info"),
      },
      {
        path: "/application/info/:id",
        name: "ApplicationInfoEdit",
        component: () => import("@/views/application/info"),
      },
    ],
  },
];
